export const ERRORS_METRICS = {
  allColumns: [
    'errors-timestamp',
    'errors-campaignname',
    'errors-category',
    'errors-message',
    'errors-url',
    'errors-referer',
    'errors-useragent',
    'errors-ip',
  ],
  defaultUnselected: [
    'errors-campaignid',
    'errors-referer',
    'errors-useragent',
    'errors-ip',
    'errors-campaignname',
  ],
  defaultSelected: [
    'errors-timestamp',
  ],
  defaultSort: [
    'errors-timestamp'
  ],
  order: {
    orderBy: 'errors-timestamp',
    orderDir: 'desc',
  },
  weight: {},
  sortExclude: [
    'errors-campaignname',
    'errors-category',
    'errors-message',
    'errors-url',
    'errors-referer',
    'errors-useragent',
    'errors-ip'
  ]
}
